import Alert from '@mui/material/Alert'

import { getTaskOverdueStatus } from '@components/Kanban/Kanban.utils'

export default function OverdueBanner({ task }) {
  const [severity, daysPassed] = getTaskOverdueStatus(task)
  if (!severity) return null

  return (
    <Alert severity={severity} variant="border">
      {severity === 'error'
        ? `This task is overdue by ${daysPassed} days! Please address immediately.`
        : `This task is due soon. ${daysPassed} days have passed. Please prioritize accordingly.`}
    </Alert>
  )
}
